import { css } from 'styled-components';

const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

/**
 * Express CSS rules from 0px upTo the breakpoint provided.
 *
 * @export
 * @param {string} breakpoint The breakpoint the rules apply up to
 * @returns
 */
export function upTo(breakpoint) {
  const breakAt = breakpoints[breakpoint] ? `${breakpoints[breakpoint] - 1}px` : breakpoint;
  return (...args) => css`
    @media (max-width: ${breakAt}) {
      ${css(...args)};
    }
  `;
}

/**
 * Express CSS rules downTo the breakpoint provided.
 *
 * @export
 * @param {string} breakpoint The breakpoint the rules apply down to
 * @returns
 */
export function downTo(breakpoint) {
  const breakAt = breakpoints[breakpoint] ? `${breakpoints[breakpoint]}px` : breakpoint;
  return (...args) => css`
    @media (min-width: ${breakAt}) {
      ${css(...args)};
    }
  `;
}
